import styled from 'styled-components'

import { helpers } from 'styles'

import { InputContainer as DefaultInputContainer } from '../Shared'

export const InputContainer = styled(DefaultInputContainer)`
	background-color: ${({ isHovered, isFocusVisible, isDisabled, isFocus, isReadOnly, hasError, theme }) => {
		if (isDisabled || isReadOnly) return theme.color.input.disabledContrast
		if (isHovered || isFocusVisible || isFocus)
			return hasError ? theme.color.input.errorContrastHover : theme.color.input.background
		return hasError ? theme.color.input.errorContrast : theme.color.input.background
	}};
	border-radius: 6px 6px 0 0;
	border: none;
	box-shadow: none;
	color: ${({ isReadOnly, isDisabled, theme }) => {
		if (isReadOnly || isDisabled) return theme.color.input.disabled
		return theme.color.input.text
	}};
	border-bottom: 1px solid ${helpers.color.border};
	margin-bottom: 12px;
	column-gap: 4px;
	padding: 12px;
`
